/**
 * 获取cs改变的类型
 */
export const getChangeSetType = (changesetInfo): ECSType => {
    if (!changesetInfo) return ECSType.All;
    if (changesetInfo?.diffs?.data?.spPr?.xfrm) return ECSType.Frame;
    if (changesetInfo?.diffs?.tableChanges?.some(e => ['add', 'remove'].includes(e.changeType))) {
        return ECSType.TableAddOrRemove;
    }
    return ECSType.NONE;
};

export enum ECSType {
    All = 'all', // 此时cs不存在，可能为初始加载阶段
    TableBorder = 'table-border',
    Frame = 'frame',
    TableAddOrRemove = 'table-add-or-remove',
    NONE = 'none', // 表明cs操作不存在
}
